import apiClient from "./config";
import { REFERAL_ENDPOINTS } from "./endpoints";

const ReferalService = {

    getReferalInfo: () => {
        return apiClient.get(REFERAL_ENDPOINTS.GET_REFERAL_INFO);
    },
    validateRefCode: (payload) => {
        return apiClient.post(REFERAL_ENDPOINTS.VALIDATE_REF_CODE, payload);
    },
    getRefLeaderBoard: () => {
        return apiClient.get(REFERAL_ENDPOINTS.REF_LEADERBOARD);
    },

};

export default ReferalService;